var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-header-wrapper',[_c('commission-settings')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }